module.exports = __webpack_public_path__ + "img/seminar (62).76d35b68.jpg";